import css from '@styled-system/css'
import React from 'react'
import { SquigglyLine } from './SquigglyLine'
import Box from '../primitives/Box'
import { applePodcastsUrl, spotifyUrl, siteEmail } from './constants'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function Sidebar({ relatedEpisodes }: { relatedEpisodes: any[] }) {
  return (
    <Box display="flex" flexDirection="column" gap={48}>
      <Box
        font="medium"
        css={`
          ${proseLinkStyles}
        `}
      >
        Follow <i>Engineering Unblocked</i> on{' '}
        <Box.a href={applePodcastsUrl} target="blank">
          Apple Podcasts
        </Box.a>
        ,{' '}
        <Box.a href={spotifyUrl} target="blank">
          Spotify
        </Box.a>
        , or in your favorite podcast app.
        <br />
        <br />
        Have a question or feedback?
        <br />
        Drop an email to <a href={`mailto:${siteEmail}`}>{siteEmail}</a>
      </Box>
      <SquigglyLine />
      <Box
        backgroundColor="podcastLightBeige"
        borderRadius={16}
        paddingY={24}
        paddingX={16}
      >
        <Box paddingLeft={16} paddingBottom={12} font="large" fontWeight={700}>
          More episodes
        </Box>
        <Box>
          {relatedEpisodes.map(episode => (
            <SidebarEpisode key={episode.slug} episode={episode} />
          ))}
        </Box>
      </Box>
    </Box>
  )
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function SidebarEpisode({ episode }: { episode: any }) {
  return (
    <Box.a
      display="block"
      href={episode.frontmatter.slug}
      font="medium"
      fontWeight={500}
      borderRadius={8}
      paddingY={24}
      paddingX={16}
      css={css({
        ':hover': {
          background: 'white',
          '.arrow': {
            backgroundColor: 'podcastBlue',
            color: 'podcastBeige',
          },
        },
      })}
    >
      {episode.frontmatter.title} · {episode.frontmatter.minutes} mins
      <Box
        className="arrow"
        display="inline-flex"
        backgroundColor="podcastBeige"
        justifyContent="center"
        //@ts-ignore -- This works
        lineHeight="20px"
        width={20}
        height={20}
        borderRadius={9999}
        marginLeft={8}
      >
        →
      </Box>
    </Box.a>
  )
}

export const proseLinkStyles = `
  a {
    color: #000;
    border-bottom: 1px solid #000;
    font-weight: 700;

    &:hover {
      border-bottom: none;
    }
  }
`
